import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconButton } from '@components/icon-button';
import { IconTrash } from '@components/icons/trash';
import { IconVisibilityShown } from '@components/icons/visibility-shown';
import { Stack } from '@components/stack';

import { useStore } from 'models/Provider';

import { Box } from 'components/Box';
import { FileUpload } from 'components/FileUpload';
import { InlineMultiSelect } from 'components/InlineMultiSelect';
import { IntegrationField } from 'components/IntegrationField';
import { Loading } from 'components/Loading';

export const QuickUpload = observer(
  ({
    id,
    loading,
    cosigners,
    cosignersChoices,
    remove,
    setFile,
    file,
    hasErrors,
    preview,
    submit,
    integration,
    items,
    validator,
  }) => {
    const { t } = useStore();
    return (
      <Box key={id} border padding="24" mt="16" inactive={loading}>
        {loading && <Loading fixed />}
        <FileUpload file={file || null} onChange={(file) => setFile(id, file)} />
        <Stack space={4}>
          {items.map((data, i) => (
            <IntegrationField data={data} validator={validator} key={i} />
          ))}
        </Stack>
        <Box key={cosigners.name} mb="16">
          <InlineMultiSelect
            label={cosigners.label}
            options={cosignersChoices}
            onChange={cosigners.setValue}
            placeholder={cosigners.label}
            defaultValue={cosigners.value}
            error={cosigners.error}
            dataId={cosigners.name}
          />
        </Box>
        <Box flex justifyContent="flex-end" mt="20">
          <Box ml="8">
            <IconButton
              tooltip={t('application.onboarding.integration.delete')}
              icon={<IconTrash />}
              onClick={() => remove(id)}
            />
          </Box>
          <Box ml="8">
            <IconButton
              tooltip={t('application.onboarding.integration.preview')}
              icon={<IconVisibilityShown />}
              disabled={loading || hasErrors}
              onClick={() => preview(id)}
            />
          </Box>
          <Box ml="8">
            <Button
              variant="primary"
              isDisabled={loading || integration.isBlocked || hasErrors}
              onClick={() => submit(false, false, id)}
              text={t('integrations.signet.button.submit')}
            />
          </Box>
        </Box>
      </Box>
    );
  }
);
